import { render, staticRenderFns } from "./order_modal.vue?vue&type=template&id=0445b46e&scoped=true&"
import script from "./order_modal.vue?vue&type=script&lang=js&"
export * from "./order_modal.vue?vue&type=script&lang=js&"
import style1 from "./order_modal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445b46e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0445b46e')) {
      api.createRecord('0445b46e', component.options)
    } else {
      api.reload('0445b46e', component.options)
    }
    module.hot.accept("./order_modal.vue?vue&type=template&id=0445b46e&scoped=true&", function () {
      api.rerender('0445b46e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/order/order_modal.vue"
export default component.exports